// extracted by mini-css-extract-plugin
export default {"playerWrapper":"index_playerWrapper__V0jv3"};